import { defineStore } from '#q-app'
import { createPinia } from 'pinia'
import router from '@/router'
import { Composer } from 'vue-i18n'
import { markRaw } from 'vue'
import RoutingService from 'shared/services/RoutingService'
import { createSentryPiniaPlugin } from '@sentry/vue'
import {
  ActionsApi,
  AdvancedSearchApi,
  AppointmentsApi,
  BusinessPartnersApi,
  BusinessUnitsApi,
  ContactPersonsApi,
  ContractsApi,
  CostCentersApi,
  UserWidgetsApi,
  LocalesApi,
  DocumentsApi,
  FoldersApi,
  IconsConfigApi,
  LocationsApi,
  NotificationsApi,
  PositionsApi,
  ResourcesApi,
  UsersApi,
  HistoryApi,
  SearchGroupingSummaryApi,
  PermissionsApi,
  UserSettingsApi,
  ListConfigApi,
  BusinessProcessApi,
  HiddenFieldsApi,
  ReleaseNotesApi,
  FeaturesApi,
  AdditionalPropertiesApi,
  GlobalSearchApi,
  HelpApi,
  AuthApi,
} from '@ceyoniq/clm-api-client'

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#Typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
    // add your custom properties here, if any

    contactPersonsApi: ContactPersonsApi
    businessPartnersApi: BusinessPartnersApi
    locationsApi: LocationsApi
    contractsApi: ContractsApi
    positionsApi: PositionsApi
    appointmentsApi: AppointmentsApi
    usersApi: UsersApi
    costCentersApi: CostCentersApi
    businessUnitsApi: BusinessUnitsApi
    documentsApi: DocumentsApi
    resourcesApi: ResourcesApi
    iconsConfigApi: IconsConfigApi
    userWidgetsApi: UserWidgetsApi
    localesApi: LocalesApi
    actionsApi: ActionsApi
    foldersApi: FoldersApi
    notificationsApi: NotificationsApi
    advancedSearchApi: AdvancedSearchApi
    searchGroupingSummaryApi: SearchGroupingSummaryApi
    historyApi: HistoryApi
    permissionsApi: PermissionsApi
    userSettingsApi: UserSettingsApi
    listConfigApi: ListConfigApi
    businessProcessApi: BusinessProcessApi
    hiddenFieldsApi: HiddenFieldsApi
    releaseNotesApi: ReleaseNotesApi
    additionalPropertiesApi: AdditionalPropertiesApi
    featuresApi: FeaturesApi
    globalSearchApi: GlobalSearchApi
    helpApi: HelpApi
    authApi: AuthApi

    routingService: RoutingService

    $i18n: Composer
  }
}

export default defineStore((/* { ssrContext } */) => {
  const pinia = createPinia()
  pinia.use(markRaw(createSentryPiniaPlugin()))

  pinia.use(({ store }) => {
    /* @ts-expect-error TSC falsely marks ´router´ as readonly */
    store.router = markRaw(router)
  })

  return pinia
})
